import React from 'react';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import infoIconSvg from 'app/assets/images/infoIcon.svg';
import { useTranslation } from 'react-i18next';
import { GenericTooltip } from '@AMIEWEB/Common/genericTooltip/GenericTooltip';
import { missingField } from 'app/constants';

interface ChargeRateTooltipProps {
  contractRegularRate: number | null;
  contractChargeAmount: number | null;
  contractShift: number | null;
  regularRateTitle: string;
  chargeAmountTitle: string;
  shiftTitle: string;
}

export const ChargeRateTooltip = ({
  contractRegularRate,
  contractChargeAmount,
  contractShift,
  regularRateTitle,
  chargeAmountTitle,
  shiftTitle
}: ChargeRateTooltipProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const chargeRates = [
    {
      title: regularRateTitle,
      rate: contractRegularRate !== null && contractRegularRate !== 0 ? `$${contractRegularRate}` : missingField,
    },
    {
      title: chargeAmountTitle,
      rate: contractChargeAmount !== null && contractChargeAmount !== 0 ? `$${contractChargeAmount}` : missingField,
    },
    {
      title: shiftTitle,
      rate: contractShift !== null && contractShift !== 0 ? `${contractShift} ${t('placement.placementMods.chargeRateTooltip.hours')}` : missingField,
    },
  ];

  const tooltipContent = (
    <Box sx={{ padding: 0.5 }}>
      {chargeRates.map((item, index) => (
        <Box key={index} display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 0.5 }}>
          <Typography variant="body2">{item.title}</Typography>
          <Typography variant="body2" sx={{ pl: 2 }}>{item.rate}</Typography>
        </Box>
      ))}
    </Box>
  );

  return (
    <>
      <GenericTooltip title={tooltipContent} placement={'bottom-end'} disableInteractive={false}>
        <IconButton sx={{ padding: '0px !important' }} disableRipple disableFocusRipple disableTouchRipple>
          <img alt={'info'} src={infoIconSvg} style={{ paddingLeft: theme.spacing(1) }} />
        </IconButton>
      </GenericTooltip>
    </>
  );
}; 